<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    
    import TabButton from './TabButton.svelte';
    let tab;

</script>
<div style="width:100%;padding:2px;box-shadow:0px 0px 2px grey;height:45px;overflow:auto;">
    <TabButton value="activities" text="Активности" logo="/img/activities.png" on:click={(e)=>{dispatch('change',{value:e.detail.value})}}/>
    <TabButton value="users" text="Пользователи" logo="/img/users.png" on:click={(e)=>{dispatch('change',{value:e.detail.value})}}/>
</div>